/**
 * Whether the login page is being shown because a session ended, rather than
 * because somebody arrived at it.
 *
 * `sessionStorage` rather than a query parameter, because the bounce is a
 * revalidation — the guard in app-layout decides the redirect, and it cannot
 * tell an expiry from a cold visit by the time it runs. Per tab, and cleared as
 * soon as it has been said once, so a second visit to /login is not haunted by
 * the first.
 */
const KEY = 'epic-hub:session-expired';

export function rememberSessionExpired(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // Private windows and locked-down settings throw rather than store. The
    // notice is a courtesy; losing it is not worth failing a sign-out over.
  }
}

/** True once, for the page that shows the notice. */
export function takeSessionExpired(): boolean {
  try {
    const expired = sessionStorage.getItem(KEY) === '1';
    if (expired) sessionStorage.removeItem(KEY);

    return expired;
  } catch {
    return false;
  }
}
